import { useState } from 'react'
import { useChatContext } from '../contexts/useChatContext'

interface AiAgentCommonQuestionsProps {
  onQuestionSelect: (question: string) => void
  isLoading: boolean
}

const QUESTIONS_NO_SELECTION = [
  'Help me choose policies to compare for this product area',
  // 'Show high-rated options (4★+)',
  // 'Which insurers have strong claims performance?',
  'What key features should I consider when selecting policies?',
  "Show policies from a specific insurer (e.g., 'QBE' or 'Allianz')",
  // 'Filter policies by a minimum rating (e.g., 4★ or 4.5★)',
  'What common exclusions should I be aware of?',
  'Explain typical excess structures',
]

const QUESTIONS_WITH_SELECTION = [
  'Summarise key differences between the selected policies',
  'Compare exclusions side by side',
  'Compare excess amounts across the selected policies',
  'Highlight unique features of each selected policy',
  'Identify coverage gaps between the selected policies',
  'Which option offers the best value considering limits and sub-limits?',
  'Link me to the wording pages that support these points',
  'Provide a concise recommendation with pros and cons for each policy',
  // 'Which insurer has the better claims experience?',
  'Generate a concise, printable comparison summary',
]

function AiAgentCommonQuestions({ onQuestionSelect, isLoading }: AiAgentCommonQuestionsProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const { hasPoliciesSelected } = useChatContext()

  function handleQuestionClick(question: string) {
    onQuestionSelect(question)
    setIsExpanded(false)
  }

  function toggleExpanded() {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className='ai-agent-common-questions'>
      <button
        className='ai-agent-common-questions-toggle'
        onClick={toggleExpanded}
        aria-label={isExpanded ? 'Hide suggested inquiries' : 'Show suggested inquiries'}
        title={isExpanded ? 'Hide suggested inquiries' : 'Show suggested inquiries'}
      >
        <span>💡</span>
        <span className='ai-agent-common-questions-text'>Suggested inquiries</span>
        <span className={`ai-agent-common-questions-arrow ${isExpanded ? 'expanded' : ''}`}>▼</span>
      </button>

      <div className={`ai-agent-common-questions-list ${isExpanded ? 'expanded' : ''}`}>
        {(hasPoliciesSelected ? QUESTIONS_WITH_SELECTION : QUESTIONS_NO_SELECTION).map(
          (question, index) => (
            <button
              key={index}
              className='ai-agent-common-question-item'
              onClick={() => handleQuestionClick(question)}
              aria-label={`Ask: ${question}`}
              disabled={isLoading}
            >
              {question}
            </button>
          ),
        )}
      </div>
    </div>
  )
}

export { AiAgentCommonQuestions }
